/**
 * 页头横幅（深色渐变 + 金点缀，业务页顶部）
 */
import type { ReactNode } from 'react';

interface PageHeroProps {
  eyebrow?: string;
  title: string;
  desc?: string;
  children?: ReactNode;
}

export default function PageHero({ eyebrow, title, desc, children }: PageHeroProps) {
  return (
    <section className="page-hero">
      <div className="container">
        {eyebrow ? <div className="page-eyebrow">{eyebrow}</div> : null}
        <h1>{title}</h1>
        {desc ? <p className="page-hero-desc">{desc}</p> : null}
        {children}
      </div>
    </section>
  );
}
